var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8957 4.16675H20.104C17.9373 4.16675 16.1665 5.91675 16.1665 8.08341V10.0417C16.1665 12.2084 17.9165 13.9584 20.0832 13.9584H29.8957C32.0623 13.9584 33.8123 12.2084 33.8123 10.0417V8.08341C33.8332 5.91675 32.0623 4.16675 29.8957 4.16675Z",
    fill: "#D8DEF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9165 10.0417C35.9165 13.3542 33.2082 16.0626 29.8957 16.0626H20.104C16.7915 16.0626 14.0832 13.3542 14.0832 10.0417C14.0832 8.87508 12.8332 8.14591 11.7915 8.68758C8.854 10.2501 6.854 13.3542 6.854 16.9167V36.5209C6.854 41.6459 11.0415 45.8334 16.1665 45.8334H33.8332C38.9582 45.8334 43.1457 41.6459 43.1457 36.5209V16.9167C43.1457 13.3542 41.1457 10.2501 38.2082 8.68758C37.1665 8.14591 35.9165 8.87508 35.9165 10.0417ZM25.7915 35.3126H16.6665C15.8123 35.3126 15.104 34.6042 15.104 33.7501C15.104 32.8959 15.8123 32.1876 16.6665 32.1876H25.7915C26.6457 32.1876 27.354 32.8959 27.354 33.7501C27.354 34.6042 26.6457 35.3126 25.7915 35.3126ZM31.2498 26.9792H16.6665C15.8123 26.9792 15.104 26.2709 15.104 25.4167C15.104 24.5626 15.8123 23.8542 16.6665 23.8542H31.2498C32.104 23.8542 32.8123 24.5626 32.8123 25.4167C32.8123 26.2709 32.104 26.9792 31.2498 26.9792Z",
    fill: "#D8DEF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardText);
export default __webpack_public_path__ + "static/media/clipboard-text.3a7fddf6e6aee599fb55709053872104.svg";
export { ForwardRef as ReactComponent };